export default class StoresCollection {
  constructor() {
    this.stores = [];
    this.limit = 20;
    this.page = 0;
    this.canLoad = true;
    this.initialized = false;
    this.query = '';
    this.sortColumn = 'stores.created_at';
    this.sortDirection = 0;
  }
}